import React, { useEffect, useState } from "react";
import {
  getAreaAuditDetailsApi,
  getAreaAuditDetailsExportApi,
  getSessionDetailsExportApi,
} from "../../services/AuditService";
import { useParams } from "react-router-dom";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import { Spinner, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { format } from "date-fns";
import { FaInfo } from "react-icons/fa";
import { FaDownload } from "react-icons/fa";
import { toast } from "react-toastify";
import { BsFileEarmarkPdfFill } from "react-icons/bs";
import { PiMicrosoftExcelLogoFill } from "react-icons/pi";
import {
  formatDateTimeWithAdd5Hours,
  getAssetScanStatusBadge,
} from "../../utilities";
import { CustomTooltip } from "../../components/CustomTooltip";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import GlobalSearchableDropdown from "../Constant/SearchableDropdown";

const assetStatusOption = [
  { label: "Verified", value: "VERIFIED" },
  { label: "Missing", value: "MISSING" },
  { label: "Misplaced", value: "MISPLACED" },
  { label: "Unassigned", value: "UNASSIGNED" },
  { label: "New", value: "NEW" },
];

const AreaAuditScanDetails = () => {
  const { sessionId, areaId } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [total, setTotal] = useState(0);
  const [statusOption, setStausOption] = useState(assetStatusOption);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [exportLoading, setExportLoading] = useState(false);
  const [param, setParam] = useState({
    query: "",
    status: "",
    page: "1",
    page_size: "10",
  });

  const getDetails = () => {
    setLoading(true);
    getAreaAuditDetailsApi(sessionId, areaId, param)
      .then((res) => {
        setError("");
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getDetails();
  }, [param]);

  useEffect(() => {
    const status = selectedStatus?.value || "";
    if (param?.status !== status) {
      setParam((prev) => ({ ...prev, status: status }));
    }
  }, [selectedStatus]);

  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: "1",
    }));
  };

  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };

  const handleExport = (type) => {
    setExportLoading(true);

    getAreaAuditDetailsExportApi(sessionId, areaId, {
      ...param,
      ...(type === "excel" ? { export: "excel" } : {}),
      ...(type === "pdf" ? { export: "pdf" } : {}),
    })
      .then((res) => {
        let mimeType = "";
        let fileExtension = "";

        if (type === "excel") {
          mimeType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          fileExtension = "xlsx";
        } else if (type === "pdf") {
          mimeType = "application/pdf";
          fileExtension = "pdf";
        }

        const blob = new Blob([res.data], { type: mimeType });

        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        const today = new Date();
        const formattedDate = today.toISOString().split("T")[0];
        a.download = `Area-Audit-Details_${formattedDate}.${fileExtension}`;

        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        window.URL.revokeObjectURL(url);
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setExportLoading(false);
      });
  };

  return (
    <div>
      <div className="mb-4 d-flex justify-content-between flex-wrap gap-2">
        <div>
          <h2 className="text-primary">Area Audit Details</h2>
          <ol className="breadcrumb breadcrumb-arrow mb-0">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Dashboard</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/auditsession">Session List</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to={`/audit-session/${sessionId}`}>Session Details</Link>
            </li>
            <li className="breadcrumb-item active">Area Audit Details</li>
          </ol>
        </div>
        <div>
          <Dropdown>
            <Dropdown.Toggle
              variant="success"
              id="dropdown-basic"
              disabled={exportLoading || data?.length == 0}
            >
              {exportLoading ? (
                <Spinner animation="border" size="sm" className="me-1" />
              ) : (
                <FaDownload className="me-1" />
              )}
              Export
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item onClick={() => handleExport("pdf")}>
                <BsFileEarmarkPdfFill className="me-1" />
                PDF
              </Dropdown.Item>
              <Dropdown.Item onClick={() => handleExport("excel")}>
                <PiMicrosoftExcelLogoFill className="me-1" />
                Excel
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      <div className="card">
        <div className="d-flex justify-content-between flex-column flex-md-row gap-2 px-4 py-3">
          <div>
            <div className="d-flex gap-1 flex-wrap">
              <span
                className="text-dark fw-medium"
                style={{ fontSize: "0.85rem" }}
              >
                Scanned Area:
              </span>
              <span
                className="text-darker fw-medium"
                style={{ fontSize: "0.88rem" }}
              >
                {data[0]?.scanned_area || "-"}
              </span>
            </div>
            <div className="d-flex gap-1 flex-wrap">
              <span
                className="text-dark fw-medium"
                style={{ fontSize: "0.85rem" }}
              >
                Auditor:
              </span>
              <span
                className="text-darker fw-medium"
                style={{ fontSize: "0.88rem" }}
              >
                {data[0]?.auditor || "-"}
              </span>
            </div>
          </div>
          <div className="d-flex flex-wrap gap-2">
            <div className="flex-fill flex-md-grow-0">
              <DebounceSmallSearchInput
                handleSearchChange={handleSearchChange}
              />
            </div>
            <GlobalSearchableDropdown
              options={statusOption}
              selected={selectedStatus}
              onSelect={(item) => setSelectedStatus(item)}
              placeholder="Status"
            />
          </div>
        </div>
        <div>
          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : error ? (
            <div className="text-center text-danger my-4">{error}</div>
          ) : data && data.length > 0 ? (
            <div className="table-responsive">
              <table className="table fs-6 mb-0 align-middle">
                <thead className="table-light custom-thead">
                  <tr>
                    <th>Scanned Code</th>
                    <th>Name</th>
                    <th>Allocated Area</th>
                    <th>Responsible User</th>
                    <th>Scanned Date</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item) => {
                    return (
                      <tr>
                        <td>
                          <Link
                            to={`/asset/${item?.asset_id}/basic-details`}
                            className="fw-medium text-primary"
                          >
                            {item?.rfid_tag_id || "-"}
                          </Link>
                        </td>
                        <td>
                          <div className="d-flex align-items-center gap-1 cursor-pointer">
                            <span>{item?.asset_name || "-"}</span>
                            <CustomTooltip
                              title={
                                <div>
                                  <div>
                                    <strong>Brand:</strong>{" "}
                                    {item?.asset_brand || "-"}
                                  </div>
                                  <div>
                                    <strong>Model No:</strong>{" "}
                                    {item?.asset_model || "-"}
                                  </div>
                                  <div>
                                    <strong>Serial No.:</strong>{" "}
                                    {item?.asset_number || "-"}
                                  </div>
                                </div>
                              }
                              placement="right"
                            >
                              <span
                                className="rounded-1 ms-1 btn btn-sm btn-outline-light"
                                style={{
                                  cursor: "pointer",
                                  padding: "0.2rem 0.2rem",
                                }}
                              >
                                <FaInfo size={9} className="text-dark" />
                              </span>
                            </CustomTooltip>
                          </div>
                        </td>
                        <td>{item?.current_allocation?.area || "-"}</td>
                        <td>
                          {item?.current_allocation?.type == "DEPARTMENT"
                            ? item?.current_allocation?.department
                            : item?.current_allocation?.type == "EMPLOYEE"
                            ? item?.current_allocation?.employee
                            : "-"}
                        </td>
                        <td>
                          {item?.scanned_at
                            ? format(item?.scanned_at, "dd MMM yyy")
                            : "-"}
                        </td>
                        <td>{getAssetScanStatusBadge(item?.status)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center my-4">
              <span>No data found</span>
            </div>
          )}

          {!loading && data?.length > 0 && (
            <div className="p-4">
              <Pagination
                currentPage={param.page}
                recordsPage={param.page_size}
                dataLength={total}
                handlePagination={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AreaAuditScanDetails;
